import { render, staticRenderFns } from "./NivelAcademicoPage.vue?vue&type=template&id=dd268a22"
import script from "./NivelAcademicoPage.js?vue&type=script&lang=js&external"
export * from "./NivelAcademicoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports